// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getTicketAuditEvents } from '@/audit/api/get-asset-audit-events';
import { AuditEventListItem } from '@/audit/components/audit-event-list-item';
import { HardfinTabCardWrapper } from '@/components/hardfin-tab-card-wrapper';
import { Stack } from '@mui/material';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/tickets/$ticketKey/audit')({
  component: AssetAuditRoute,
});

function AssetAuditRoute() {
  const { ticketKey } = Route.useParams();

  const { data } = useSuspenseQuery({
    queryKey: ['ticket', ticketKey, 'audit'],
    queryFn: () => getTicketAuditEvents(ticketKey),
    retry: false,
  });

  return (
    <HardfinTabCardWrapper title="Audit log">
      <Stack spacing={2}>
        {data.events.map((event) => (
          <AuditEventListItem key={event.id} event={event} />
        ))}
      </Stack>
    </HardfinTabCardWrapper>
  );
}
